import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import RemoveEmployeeBtn from './RemoveEmployeeBtn';
import {
  getAllEmployeesInitiate,
  getEmployeesForGroupInitiate,
  removeEmployeeFromCompanyInitiate,
} from '../../../../actions/employee';
import { currentFlowTypeEnum } from '../constants';

const mapStateToProps = state => {
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const viewOnlyMode = _get(state, 'user.view_only_mode', false);

  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  return {
    currentFlow,
    viewOnlyMode,
    selectedWorkspace,
    fetchingEmployees:
      _get(state, 'apiState.GET_EMPLOYEES_FOR_GROUP.isFetching', true) &&
      !_get(state, 'apiState.GET_EMPLOYEES_FOR_GROUP.isIdle', false),
    fetchedEmployees: _get(
      state,
      'apiState.GET_EMPLOYEES_FOR_GROUP.success',
      true,
    ),
    removingEmployeeFromCompany:
      _get(state, 'apiState.REMOVE_EMPLOYEE_FROM_COMPANY.isFetching', false) &&
      !_get(state, 'apiState.REMOVE_EMPLOYEE_FROM_COMPANY.isIdle', false),
    removedEmployeeSuccess: _get(
      state,
      'apiState.REMOVE_EMPLOYEE_FROM_COMPANY.success',
      false,
    ),
  };
};

const mapDispatchToProps = dispatch => ({
  getEmployeesForGroup: payload =>
    dispatch(getEmployeesForGroupInitiate(payload)),
  removeEmployeeFromCompany: payload =>
    dispatch(removeEmployeeFromCompanyInitiate(payload)),
  getAllEmployees: payload => dispatch(getAllEmployeesInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RemoveEmployeeBtn);
